import { useCallback, useState, useEffect } from 'react';
import { Grid } from '@material-ui/core';
import ModalContainer from 'components/molecules/ModalContainer';
import useProductsIM from 'hooks/useProductsIM';
import IMProductsList from 'components/organisms/IMProductsList';
import IMProductForm from 'components/organisms/IMProductsForm/IMProductForm';
import useCategoriesIM from 'hooks/useCategoriesIM';
import useProvidersIM from 'hooks/useProvidersIM';
import { IProductForm, IProductList } from 'interfaces/imProducts.interface';
import { ICategories, ICategoriesList, ICategoriesPromotion } from 'interfaces/imCategories.interface';
import { iProviders } from 'interfaces/imProviders.interface';

export default function Inventory() {
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [productId, setProductId] = useState('');
  const [parentId, setParentId] = useState(0);
  const [productsList, setProductsList] = useState<IProductList>({
    total: 0,
    products: []
  });
  const [providers, setProviders] = useState<iProviders[]>([]);
  const [categories, setCategories] = useState<ICategories[]>([]);
  const [categoriesPromo, setCategoriesPromo] = useState<ICategoriesPromotion[]>([]);

  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);

  const { getProducts, updateProduct } = useProductsIM();
  const { getCategories } = useCategoriesIM();
  const { getProvidersActive } = useProvidersIM();
  const handleOnCloseModal = () => {
    setOpenModalEdit(false);
  };

  const getAllCategories = () => {
    getCategories().then((result: ICategoriesList) => {
      if (result) {
        setCategories(result.categories);
        setCategoriesPromo(result.categoriesPromotion);
      }
    });
  };

  const getAllProviders = () => {
    getProvidersActive().then((result: iProviders[]) => {
      if (result) {
        setProviders(result);
      }
    });
  };

  const getAllProducts = useCallback(() => {
    getProducts(page, rowsPerPage, '').then((result: any) => {
      setProductsList(result);
    });
  }, [page, rowsPerPage]);

  const saveProduct = (data: IProductForm, productId: string) => {
    return updateProduct(data, productId);
  };

  const handleOnClickEditProduct = (productId: string) => {
    setProductId(productId);
    setOpenModalEdit(true);
  };

  useEffect(() => {
    getAllCategories();
    getAllProviders();
  }, []);

  return (
    <Grid container justify="center" spacing={2}>
      <Grid item xs={12} sm={12} md={10}>
        <IMProductsList
          handleOnClickEditProduct={handleOnClickEditProduct}
          productsList={productsList}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setProductsList={setProductsList}
          setParentId={setParentId}
          parentId={parentId}
          setRowsPerPage={setRowsPerPage}
          getAllProducts={getAllProducts}
        />
      </Grid>
      <ModalContainer title="Editar producto" open={openModalEdit} onClose={handleOnCloseModal}>
        <IMProductForm
          handleCloseModal={handleOnCloseModal}
          handleOnSubmit={saveProduct}
          productId={productId}
          parentId={parentId}
          getAllProducts={getAllProducts}
          providers={providers}
          categories={categories}
          categoriesPromo={categoriesPromo}
        />
      </ModalContainer>
    </Grid>
  );
}
